import TicketDetailsPage from './TicketDetails';

export { TicketDetailsPage };
export default TicketDetailsPage;
